// /src/pages/private/admin/PrivateDocuments/donatePanel/donatePanelUtils.js

export const EMPTY_COST_ROW = {
  category: '',
  description: '',
  amountLabel: '',
};

export function isCostRowEmpty(row) {
  const category = String(row?.category ?? '').trim();
  const description = String(row?.description ?? '').trim();
  const amountLabel = String(row?.amountLabel ?? '').trim();
  return !category && !description && !amountLabel;
}

export function normalizeRowsForSave(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row, index) => ({
      sortOrder: index,
      category: String(row?.category ?? '').trim(),
      description: String(row?.description ?? '').trim(),
      amountLabel: String(row?.amountLabel ?? '').trim(),
    }))
    .filter((row) => !isCostRowEmpty(row));
}

export function withTrailingEmptyRow(rows) {
  const list = Array.isArray(rows) ? rows.map((row) => ({ ...EMPTY_COST_ROW, ...row })) : [];
  if (list.length === 0 || !isCostRowEmpty(list[list.length - 1])) {
    list.push({ ...EMPTY_COST_ROW });
  }
  return list;
}

export function splitIntroParagraphs(introText) {
  return String(introText || '')
    .split(/\n\s*\n/)
    .map((part) => part.trim())
    .filter(Boolean);
}
